import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "maplibre-gl/dist/maplibre-gl.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import planinMarkUrl from "../../visualization/public/planin-logo-mark.png";
import App from "./App";
import "./styles/tokens.css";
import "./styles/app.css";

const icon = document.createElement("link");
icon.rel = "icon";
icon.type = "image/png";
icon.href = planinMarkUrl;
document.head.append(icon);

createRoot(document.getElementById("root")!).render(
  <StrictMode><App /></StrictMode>,
);

